
  import { defineComponent, onMounted, ref, computed } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    name: 'registered-trades-grouping-creating',
    components: {
      ErrorMessage,
      Field,
      Form,
      Multiselect,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const thumbnail = ref('/media/avatars/blank-image.jpg');
      const { can } = useAbility();
      const selectedDescriptionIds = ref<number[]>([]);
      const registeredDescs = computed(
        () => store.getters.getRegisteredDesc || []
      );

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      const previewImage = (e) => {
        const file = e.target.files[0];
        thumbnail.value = URL.createObjectURL(file);
      };

      const registeredTradesGroupingSchema = Yup.object().shape({
        titleEn: Yup.string()
          .required(() => translate('EN_NAME_IS_REQUIRED_FIELD'))
          .label('English Name'),
        titleAr: Yup.string()
          .required(() => translate('AR_NAME_IS_REQUIRED_FIELD'))
          .label('Arabic Name'),
      });

      const fireError = () => {
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];
        Swal.fire({
          text: translate(error[0]),
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: translate('tryAgainExcl'),
          customClass: {
            confirmButton: 'btn fw-bold btn-light-danger',
          },
        });
        //Deactivate indicator
        submitButton.value?.removeAttribute('data-kt-indicator');
        // eslint-disable-next-line
      submitButton.value!.disabled = false;
      };

      const onSubmitCreate = async (values) => {
        if (submitButton.value) {
          // eslint-disable-next-line
        submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        values.relatedIds = selectedDescriptionIds.value;

        if (values.sort) {
          values.sort = Number(values.sort);
        }

        const iconFile = values.icon;
        delete values.icon;

        const iconFormData = new FormData();
        // eslint-disable-next-line
      iconFormData.append('images', values.icon);

        delete values.icon;

        const grouping = await store.dispatch(
          Actions.CREATE_REGISTERED_TRADES_GROUPING,
          values
        );

        if (!grouping?.id) {
          fireError();
        } else {
          if (iconFile) {
            const iconFormData = new FormData();
            iconFormData.append('images', iconFile);

            const icon = await store.dispatch(
              Actions.UPLOAD_REGISTERED_TRADES_ICON,
              {
                data: iconFormData,
                groupingId: grouping.id,
              }
            );
          }
          if (!grouping) {
            Swal.fire({
              text: translate(''),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
            //Deactivate indicator
            submitButton.value?.removeAttribute('data-kt-indicator');
            // eslint-disable-next-line
          submitButton.value!.disabled = false;
          } else {
            Swal.fire({
              text: translate('SUCCESSFULLY_CREATED_REGISTERED_TRADE_GROUPING'),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            }).then(() => {
              router.push({ name: 'registered-trades-grouping-listing' });
            });
          }
        }
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('registeredTradesGroupingCreate'), [
          translate('registered-trades'),
        ]);
        await store.dispatch(Actions.GET_REGISTERED_TRADES_ASSETS, 6);
      });
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onSubmitCreate,
        submitButton,
        translate,
        registeredTradesGroupingSchema,
        previewImage,
        thumbnail,
        goBack,
        can,
        selectedDescriptionIds,
        registeredDescs,
      };
    },
  });
